<script>
import { mapActions } from 'vuex';
import { API_ROOT } from '../../config';
import api from '../../_api';

export default {
  data() {
    return {
      errors: [],
      message: '',
    };
  },
  methods: {
    ...mapActions('account', ['salesforcelogin']),
    date() {
      return new Date().toISOString();
    },
  },
  mounted() {
    const { code } = this.$route.query;
    const { state } = this.$route.query;
    api.get(`${API_ROOT}/salesforce/retrieve_access_token/${state}/${code}`).then((r) => {
      const data = JSON.parse(r.data.res);
      if (data.error) {
        throw Error(`Error: ${data.error}: ${data.error_description}`);
      }
      const instanceUrl = data.instance_url;
      const accessToken = data.access_token;
      this.salesforcelogin({ instanceUrl, accessToken });
    }).catch((error) => {
      this.errors.push(error);
      this.message = error.response.data;
    });
  },
};
</script>

<template>
  <div v-if="errors.length == 0">
    Redirecting to seer ...
  </div>
  <div v-else>
    Query: {{ $route.query }}
    <div
      v-for="(error, index) in errors"
      :key="`email_errors_${index}`"
    >
      <div>
        {{ error }} <br>
        {{ message }} <br>
        {{ date() }}
      </div>
    </div>
  </div>
</template>

<style>

</style>
